module.exports = __webpack_public_path__ + "static/media/smite.7a286f48.jpg";